/**
 * ![orange 50](https://mui.com/static/colors-preview/orange-50-24x24.png) ![orange 100](https://mui.com/static/colors-preview/orange-100-24x24.png) ![orange 200](https://mui.com/static/colors-preview/orange-200-24x24.png) ![orange 300](https://mui.com/static/colors-preview/orange-300-24x24.png) ![orange 400](https://mui.com/static/colors-preview/orange-400-24x24.png) ![orange 500](https://mui.com/static/colors-preview/orange-500-24x24.png) ![orange 600](https://mui.com/static/colors-preview/orange-600-24x24.png) ![orange 700](https://mui.com/static/colors-preview/orange-700-24x24.png) ![orange 800](https://mui.com/static/colors-preview/orange-800-24x24.png) ![orange 900](https://mui.com/static/colors-preview/orange-900-24x24.png) ![orange A100](https://mui.com/static/colors-preview/orange-A100-24x24.png) ![orange A200](https://mui.com/static/colors-preview/orange-A200-24x24.png) ![orange A400](https://mui.com/static/colors-preview/orange-A400-24x24.png) ![orange A700](https://mui.com/static/colors-preview/orange-A700-24x24.png)
 */
const orange = {
  /**
   * Preview: ![orange 50](https://mui.com/static/colors-preview/orange-50-24x24.png)
   */
  50: '#fff3e0',
  /**
   * Preview: ![orange 100](https://mui.com/static/colors-preview/orange-100-24x24.png)
   */
  100: '#ffe0b2',
  /**
   * Preview: ![orange 200](https://mui.com/static/colors-preview/orange-200-24x24.png)
   */
  200: '#ffcc80',
  /**
   * Preview: ![orange 300](https://mui.com/static/colors-preview/orange-300-24x24.png)
   */
  300: '#ffb74d',
  /**
   * Preview: ![orange 400](https://mui.com/static/colors-preview/orange-400-24x24.png)
   */
  400: '#ffa726',
  /**
   * Preview: ![orange 500](https://mui.com/static/colors-preview/orange-500-24x24.png)
   */
  500: '#ff9800',
  /**
   * Preview: ![orange 600](https://mui.com/static/colors-preview/orange-600-24x24.png)
   */
  600: '#fb8c00',
  /**
   * Preview: ![orange 700](https://mui.com/static/colors-preview/orange-700-24x24.png)
   */
  700: '#f57c00',
  /**
   * Preview: ![orange 800](https://mui.com/static/colors-preview/orange-800-24x24.png)
   */
  800: '#ef6c00',
  /**
   * Preview: ![orange 900](https://mui.com/static/colors-preview/orange-900-24x24.png)
   */
  900: '#e65100',
  /**
   * Preview: ![orange A100](https://mui.com/static/colors-preview/orange-A100-24x24.png)
   */
  A100: '#ffd180',
  /**
   * Preview: ![orange A200](https://mui.com/static/colors-preview/orange-A200-24x24.png)
   */
  A200: '#ffab40',
  /**
   * Preview: ![orange A400](https://mui.com/static/colors-preview/orange-A400-24x24.png)
   */
  A400: '#ff9100',
  /**
   * Preview: ![orange A700](https://mui.com/static/colors-preview/orange-A700-24x24.png)
   */
  A700: '#ff6d00',
} as const;

export default orange;
